import InlineForm from "./inline-form";

export const schema = {
    operationalReviewDate: {
        name: "Operational Review Date",
        type: "date",
        placeholder: "",
        style: {
            minWidth: "20ch",
        },
        searchable: true,
    },
    changesToSGNo: {
        name: "Changes to Supervision Guideline no:",
        type: "text",
        placeholder:"Enter Changes to Supervision Guideline no",
        style: {
            minWidth: "20ch",
        },
        searchable: true,
    },
    emailSentToStaffAdvising : {
        name: "Email Sent to Staff Advising",
        type: "text",
        placeholder: "Enter Email Sent to Staff Advising",
        style: {
            minWidth: "20ch",
        },
        searchable: true,
    },
    signedByLicensee: {
        name: "Signed by Licensee",
        type: "text",
        placeholder: "Enter Signed by Licensee",
        style: {
            minWidth: "20ch",
        },
    }
};

const SG10ReviewOfOperatingProcedure = ({ formType, formTitle }) => {
    return <InlineForm schema={schema} formTitle={formTitle} formType={formType} />
};

export default SG10ReviewOfOperatingProcedure;
